/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PipelineNewTeams_organization$ref = any;
export type PipelineNewTeamsRendererQueryVariables = {|
  slug: string
|};
export type PipelineNewTeamsRendererQueryResponse = {|
  +organization: ?{|
    +$fragmentRefs: PipelineNewTeams_organization$ref
  |}
|};
export type PipelineNewTeamsRendererQuery = {|
  variables: PipelineNewTeamsRendererQueryVariables,
  response: PipelineNewTeamsRendererQueryResponse,
|};
*/


/*
query PipelineNewTeamsRendererQuery(
  $slug: ID!
) {
  organization(slug: $slug) {
    ...PipelineNewTeams_organization
    id
  }
}

fragment Labels_team on Team {
  privacy
}

fragment MemberTeamRow_team on Team {
  ...Labels_team
  id
  uuid
  name
  description
}

fragment PipelineNewTeams_organization on Organization {
  teams(first: 500) {
    edges {
      node {
        ...MemberTeamRow_team
        uuid
        permissions {
          pipelineView {
            allowed
          }
          teamPipelineCreate {
            allowed
          }
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelineNewTeamsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PipelineNewTeams_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelineNewTeamsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 500
              }
            ],
            "concreteType": "TeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privacy",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "uuid",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPermissions",
                        "kind": "LinkedField",
                        "name": "permissions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Permission",
                            "kind": "LinkedField",
                            "name": "pipelineView",
                            "plural": false,
                            "selections": (v3/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Permission",
                            "kind": "LinkedField",
                            "name": "teamPipelineCreate",
                            "plural": false,
                            "selections": (v3/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "teams(first:500)"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a1e0041322f50ccfc90de4a55408409",
    "id": null,
    "metadata": {},
    "name": "PipelineNewTeamsRendererQuery",
    "operationKind": "query",
    "text": "query PipelineNewTeamsRendererQuery(\n  $slug: ID!\n) {\n  organization(slug: $slug) {\n    ...PipelineNewTeams_organization\n    id\n  }\n}\n\nfragment Labels_team on Team {\n  privacy\n}\n\nfragment MemberTeamRow_team on Team {\n  ...Labels_team\n  id\n  uuid\n  name\n  description\n}\n\nfragment PipelineNewTeams_organization on Organization {\n  teams(first: 500) {\n    edges {\n      node {\n        ...MemberTeamRow_team\n        uuid\n        permissions {\n          pipelineView {\n            allowed\n          }\n          teamPipelineCreate {\n            allowed\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '70e694c04efe4d8cbd31567df62d6842';

module.exports = node;
